export const EXTERNAL_URLS = {
  // Community translation project
  crowdinProject: 'https://crowdin.com/project/moneymatter',
  // Public roadmap: what is planned/in-progress. Read-only view for users
  featurebaseRoadmap: 'https://moneymatter.featurebase.app/dashboard/roadmap',
  // Feedback board: where users submit and upvote requests
  featurebaseBoard: 'https://moneymatter.featurebase.app/',
  docs: 'https://docs.moneymatter.app',
} as const;
